import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {Radio} from 'react-radio-group';

import styles from './RadioButton.scss';

export default class RadioButton extends Component {
    static propTypes = {
        className: PropTypes.string,
        label: PropTypes.string,
        fieldKey: PropTypes.string,
        value: PropTypes.any.isRequired,
        disabled: PropTypes.bool,
        error: PropTypes.any,
        children: PropTypes.any,
        activeClassName: PropTypes.string,
        isActive: PropTypes.bool
    };


    render() {
        const {value, label, fieldKey, children, disabled, error, className, activeClassName, isActive} = this.props;
        const labelClassName = classnames(styles.radioButtonLabel, {
            [styles.error]: error,
            [styles.disabled]: disabled
        });
        const containerClassName = classnames(styles.radioButtonContainer, className,
            activeClassName && isActive ? activeClassName : '');

        return (
            <div className={styles.radioButtonWrapper}>
                <div className={containerClassName}>
                    <Radio className={styles.radioButton}
                           id={`${fieldKey}_${value}_option`}
                           value={value}
                           disabled={disabled}/>
                    <div className={classnames(styles.check, {[styles.disabled]: disabled})} onClick={() => {
                        this.refs.option.click()
                    }}/>
                    <label ref={`option`} className={labelClassName}
                           htmlFor={`${fieldKey}_${value}_option`}>
                        {label}
                    </label>
                </div>
                <div className={styles.innerWrapper}>
                    {children}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/controls/RadioButton.js